// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__4QnfA","header":"default_header__2XatU","content":"default_content__7XlkR"};